import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ResizeEvent } from "angular-resizable-element";
import { ToastrService } from "ngx-toastr";
import { DocumentResult } from "../../../models/document-result";
import { DocumentResultControllerService } from "../../../services/result-controller/document-result-controller.service";
import { Registration } from "../../../models/registration";
import { ModalService } from "../../utils/base_modal.component";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {DeterminantControllerService} from "../../../services/registration-controller/determinant-controller.service";

@Component({
  selector: "results-table",
  templateUrl: "./results-table.component.html",
  providers: [DocumentResultControllerService, ModalService, ToastrService],
  styles: [".cursor-hand {cursor: pointer;}"],
})
export class ResultsTableComponent extends TranslatedBaseError implements OnInit {

  @Input() public hideList: boolean = false;
  public serviceId: string;
  public determinantMapById: { [key: string]: string } = {};
  public documentResults: any[] = [];
  public allRegistrations: Registration[];

  public style: object = {};
  public result: any;
  public showEdit: boolean = false;
  public showAdd: boolean = false;

  public isLoading: boolean = false;
  public elementsNumber: string;

  constructor(private route: ActivatedRoute,
              private documentResultControllerService: DocumentResultControllerService,
              private determinantService: DeterminantControllerService,
              private router: Router,
              toastr: ToastrService,
              public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.getServiceDeterminantKeyName();
    });
    this.getSystemDocumentResults();
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public sortNotification(event) {
    this.specifySortNumbers(this.documentResults);
  }

  public specifySortNumbers(res: DocumentResult[]) {
    let sortNumber = 0;
    res.forEach((r) => {
      sortNumber = sortNumber + 1;
      r.sortOrder = sortNumber;
    });
  }

  public getSystemDocumentResults() {
    this.documentResultControllerService.getAllResults(this.serviceId).subscribe(
      (data) => {
        const results = data;
        results.forEach((item) => item.name = item.requirement.name);
        this.documentResults = this.sortResults(results);
        this.elementsNumber = " (" + this.documentResults.length + ")";
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public deleteDocumentResult(documentresult) {
    this.documentResultControllerService.deleteRegistrationResult(documentresult.id).subscribe(
      (data) => {
        this.responseSuccessful("Result successfully deleted!");
        this.ngOnInit();
        this.router.navigate(["/services/" + this.serviceId + "/resultstable"]);
      },
      (error) => this.showErrorMessageWithTitle("Result delete error! ", error),
    );
  }

  public sortResults(results: any[]) {
    return results.sort((a, b) => {
      const num1 = a.name;
      const num2 = b.name;
      return (num1 < num2) ? -1 : (num1 > num2) ? 1 : 0;
    });
  }

  public loadResult(result) {
    if (result) {
      this.result = this.documentResults.find((it) => {
        return it.id === result.id;
      });
      this.showEdit = true;
    } else {
      this.result = new DocumentResult();
      this.showAdd = true;
    }
  }

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }

  public closeSlider() {
    this.getSystemDocumentResults();
    this.closeLayers();
  }

  public closeLayers() {
    this.showAdd = false;
    this.showEdit = false;
    this.style = {};
  }

}
